export default __webpack_public_path__ + "images/Complete-Check-In.png";